module.exports = __webpack_public_path__ + "img/icon-clients-gray-dark.8d6bef77.svg";